function adaptiveGap({ min = 40, max = 140, vw = 10 } = {}) {
	const val = window.innerWidth * vw / 100;
	return Math.max(min, Math.min(val, max));
}

function createGhostsForAllTitles({
	selector = '.content__title-wrapper',
	ghostsLeft = 5,
	ghostsRight = 5,
	leftBase = '20%',
	minPadding = 16
} = {}) {
	document.querySelectorAll(selector).forEach(wrapper => {
		wrapper.querySelectorAll('.ghost').forEach(e => e.remove());

		const main = wrapper.querySelector('.black-text');
		if (!main) return;

		main.style.maxWidth = '100%';
		main.style.whiteSpace = 'normal';
		main.style.wordBreak = 'break-word';

		const ghostText = main.dataset.ghost !== undefined ? main.dataset.ghost : main.textContent;
		const ww = window.innerWidth;

		const gapFirst = adaptiveGap({ min: 40, max: 140, vw: 10 });
		const gap = adaptiveGap({ min: 40, max: 140, vw: 10 });

		let leftPos = leftBase;
		if (ww < 400) leftPos = '10px';

		main.style.position = 'absolute';
		main.style.left = leftPos;
		main.style.transform = 'none';

		const mainWidth = main.offsetWidth;
		// Если хочешь чтобы при слишком большом заголовке призраки пропадали — раскомментируй return ниже:
		// if (mainWidth + minPadding * 2 > ww) return;

		const leftGhosts = [];
		const rightGhosts = [];

		// Призраки слева
		for (let i = ghostsLeft; i > 0; i--) {
			const g = main.cloneNode(true);
			g.className = `ghost ghost--left ghost--${i}`;
			g.textContent = ghostText;
			g.style.maxWidth = 'none';
			g.style.whiteSpace = 'nowrap';
			g.style.overflow = 'visible';
			g.style.wordBreak = 'normal';
			g.style.opacity = '1';
			wrapper.insertBefore(g, main);
			leftGhosts.unshift(g);
		}
		// Призраки справа
		for (let i = 1; i <= ghostsRight; i++) {
			const g = main.cloneNode(true);
			g.className = `ghost ghost--right ghost--${i}`;
			g.textContent = ghostText;
			g.style.maxWidth = 'none';
			g.style.whiteSpace = 'nowrap';
			g.style.overflow = 'visible';
			g.style.wordBreak = 'normal';
			g.style.opacity = '1';
			wrapper.appendChild(g);
			rightGhosts.push(g);
		}

		requestAnimationFrame(() => {
			const mainWidth = main.offsetWidth;

			// СЛЕВА
			let offset = -gapFirst;
			for (let i = 0; i < leftGhosts.length; i++) {
				const g = leftGhosts[i];
				const w = g.offsetWidth;
				offset -= w;
				g.style.left = `calc(${leftPos} + ${offset}px)`;
				g.style.transform = 'none';
				offset -= gap;
			}

			// СПРАВА
			offset = mainWidth + gapFirst;
			for (let i = 0; i < rightGhosts.length; i++) {
				const g = rightGhosts[i];
				const w = g.offsetWidth;
				g.style.left = `calc(${leftPos} + ${offset}px)`;
				g.style.transform = 'none';
				offset += w + gap;
			}
		});
	});
}

// ---- Дебаунс (чтобы не дергалось на resize) ----
let ghostResizeTimeout = null;
function runGhostsDebounced() {
	if (ghostResizeTimeout) clearTimeout(ghostResizeTimeout);
	ghostResizeTimeout = setTimeout(() => createGhostsForAllTitles(), 80);
}

// ---- Запуск при загрузке и при ресайзе ----
document.addEventListener('DOMContentLoaded', () => {
	if (document.fonts) {
		document.fonts.ready.then(runGhostsDebounced);
	} else {
		runGhostsDebounced();
	}
});
window.addEventListener('resize', runGhostsDebounced);

export default createGhostsForAllTitles;
